// extracted by mini-css-extract-plugin
module.exports = {"iamfixed":"Drope_iamfixed__1PTNo","cloud":"Drope_cloud__1o863"};